import Dialog, { type DialogProps } from '@/components/Dialog';

type ColorsManagerDialogProps = Omit<DialogProps, 'PaperProps'>;

const ColorsManagerDialog = (props: ColorsManagerDialogProps) => (
  <Dialog
    slotProps={{
      paper: {
        style: {
          maxWidth: 480,
        },
      },
    }}
    {...props}
  />
);

export default ColorsManagerDialog;
